export const servicePlanStatuses = {
  0: 'Pending',
  1: 'Active',
  4: 'Cancelled',
};

export const paymentMethodTypes = {
  0: 'Cash',
  1: 'Check',
  2: 'Card',
  3: 'Other',
  4: 'Credit',
};

export const paymentStatuses = {
  0: 'Not paid',
  1: 'Pending',
  2: 'Paid',
  3: 'Failed',
  4: 'Voided',
  5: 'Refunded',
};

export const visitStatues = {
  0: 'Unscheduled',
  1: 'Scheduled',
  2: 'On the way',
  3: 'In process',
  4: 'Finished',
  5: 'Canceled',
};
